import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { EncriptyUtilService } from './encripty-util.service';
import * as moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class ExportPdfService {

    public customLogin;

    constructor(
        private encriptyService: EncriptyUtilService,
    ) {
        let resCustom = localStorage.getItem('bway-customLogin');
        this.customLogin = JSON.parse(resCustom);
    }

    exportPdf(nomeRelatorio, colunas, dados, dataHeader, configReport?) {

        const columnStyles = configReport != null && configReport.columnStyles != null
            ? configReport.columnStyles : {};

        const contentMargin = configReport != null && configReport.contentMargin != null
            ? configReport.contentMargin : { top: 55, bottom: 15, left: 5, right: 5 };    

        const config: any = {
            orientation: 'p',
            unit: 'mm',
            format: 'a4',
            putOnlyUsedFonts: true,
        }

        const doc = new jsPDF(config);
        const content: any = {
            margin: contentMargin,
            image: { type: 'png', quality: 0.98 },
            body: dados,
            columns: colunas,
            headStyles: {
                fillColor: this.customLogin.primaria,
                textColor: this.customLogin.label,
            },
            beforePageContent: this.header(doc, dataHeader),
            columnStyles: columnStyles,
            footStyles: {
                fontStyle: 'bold',
                fillColor: '#E1E1E1',
                textColor: '#000000'
            },
            showFoot: "lastPage",
        }

        autoTable(doc, content);
        this.header(doc, dataHeader);
        this.addFooters(doc);
        this.generatePDF(doc, dataHeader);
        doc.save(nomeRelatorio + '.pdf');

    }

    header(doc, dataHeader) {

        const collor = this.customLogin.primaria;
        const imgData = 'data:application/png;base64,' + this.customLogin.headerMenu;

        doc.addImage(imgData, 4, 15, 50, 15);
        doc.setFont("bold");

        dataHeader.map(data => {
            doc.setFontSize(10);
            if (data.style != null) {
                if(data.style.fontSize != null){
                    doc.setFontSize(data.style.fontSize);
                }
                if (data.style.textAlignRight != null && data.style.textAlignRight) {
                    const pageWidth = doc.internal.pageSize.getWidth();
                    const textWidth = doc.getTextWidth(data.value);
                    data.marginLeft = pageWidth - textWidth - 20;
                }
                
            }

            doc.text(data.property + ": " + data.value, data.marginLeft, data.marginTop, data.style);
        });

        doc.setFillColor(collor);
        doc.line(5, 38, 205, 38, 'F');

    }

    addFooters(doc) {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFontSize(10);
        doc.setFont("bold");
        
        for (var i = 1; i <= pageCount; i++) {
            doc.setPage(i)
            doc.text('Página ' + String(i) + ' de ' + String(pageCount), 180, 287);
        }        

    }

    generatePDF(doc, dataHeader) {

        const pageCount = doc.internal.getNumberOfPages();

        for (let i = 0; i < pageCount; i++) {
            doc.setPage(i + 1);
            this.header(doc, dataHeader);
        }
        doc.setPage(1);
    }
}